import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './lang/config'
import store from './store/config'
import vuetify from './plugins/vuetify'
import eventBus from './plugins/events'
import formatters from './plugins/formatters'
import helper from './mixins/helpers'
import api from './mixins/api_services'
import constants from './mixins/constants'
import VueCookie from 'vue-cookie'
import axios from 'axios'
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'

const filters = {
  dateFormat: helper.methods.$_filterDate,
  dateTimeFormat: helper.methods.$_filterDateTime,
  replaceDotWithComma: helper.methods.$_replaceDotWithComma,
  replaceDotWithCommaWOFixed: helper.methods.$_replaceDotWithCommaWOFixed,
  absoluteNumber: helper.methods.$_absoluteNumber,
  replaceCommaWithDot: helper.methods.$_replaceCommaWithDot
}
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const mixins = { constants, api, helper }
Object.keys(mixins).forEach(key => {
  Vue.mixin(mixins[key])
})

Highcharts.setOptions({
  colors: ['#185e98', '#b0bec5', '#8c9eff', '#ff5252', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
})
Vue.use(VueHighcharts, { Highcharts })

const plugins = { formatters, VueCookie, eventBus }
Object.keys(plugins).forEach(key => {
  Vue.use(plugins[key])
})

Vue.config.productionTip = false
axios.defaults.imageURL = process.env.VUE_APP_IMAGE_URL
axios.defaults.baseURL = process.env.VUE_APP_URL
axios.defaults.headers.common = {
  Authorization: `Bearer ${VueCookie.get(process.env.VUE_APP_TOKEN)}`
}

export const handleError = (error, self) => {
  if (error.response) {
    let err = error.response
    if (error.response.data) err = error.response.data
    else err = `Status Code : ${error.response.status}, Message : ${error.response.statusText}`
    self.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(err) })
    if (error.response.status === 401) {
      self.$root.$emit('snackbar', { snackbar: true, color: 'error', text: self.$t('message.common.authorised_failed') })
      self.$store.dispatch('logout')
      self.$router.push('/login')
    }
  } else {
    self.$root.$emit('snackbar', { snackbar: true, color: 'error', text: error.message })
    console.log(error)
  }
  // self.$store.commit('hideLoader')
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
